"use client";

import { useEffect, useRef } from "react";
import { Comments } from "@hyvor/hyvor-talk-react";
import { type CommentsCustomElement } from "@hyvor/hyvor-talk-base";

type HyvorCommentingPluginTypes = {
  pageId: string;
};
export function HyvorCommentingPlugin(props: HyvorCommentingPluginTypes) {
  const commentRef = useRef<{ element: () => CommentsCustomElement }>(null);

  useEffect(() => {
    if (commentRef.current) {
      const commentRefElem = commentRef.current.element();
      commentRefElem.addEventListener("loaded", () => {
        setTimeout(() => {
          const linkRefElem = commentRefElem.shadowRoot
            ?.querySelector("#root")
            ?.querySelector("#app")
            ?.querySelector(".main-box-footer");

          if (linkRefElem) linkRefElem.remove();
        }, 0.1);
      });
    }
  }, []);

  return (
    <Comments website-id={14445} page-id={props.pageId} ref={commentRef} />
  );
}
